import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from '../../Service/Loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() isLoading: boolean = false;
  constructor(private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.loaderService.isLoading$.subscribe((status: boolean) => {
      this.isLoading = status;
    });
  }
}
